import { BaseRelationModel } from "./base-relation";
import { CICEnabled } from "./../interfaces/cic-enabled";
import { Treatment } from "./treatment";
import { prop } from "../../decorators/property";
import { Court } from "./court";

export class CaseRelationModel extends BaseRelationModel implements CICEnabled {

    @prop() public ForceShow: boolean;
    @prop() public FilteredOut: boolean;
    @prop() public Collapsed: boolean;
    @prop() public SemiCollapsed: boolean;
    @prop() public IsHiddenJurisdiction: boolean;
    @prop() public Court: Court;
    @prop() public FriendlyUrlTitle: string;
    @prop() public Url: string;
    @prop() public TreatmentOptions: any;
    @prop() public ContextParaCount: number;
    @prop() public PluralContext: boolean;
    @prop() public HasContext: boolean;
    @prop() public TreatmentClass: string;
    @prop() public Treatment: Treatment;
    @prop() public Summary: string;
    @prop() public TruncatedSummary: string;
    @prop() public DisplayJurisdiction: string;
    @prop() public CitedReferences: number;
    @prop() public HideJurisdictionFlag: boolean;
    @prop() public HideYear: boolean;
    @prop() public HideCourt: boolean;
    @prop() public TreatmentFilteredOut: boolean;
    @prop() public EditorialStatus: string;
    @prop() public HowCited: string;
    @prop() public CitedCasePriority: number;
    @prop() public CitingCasePriority: number;

    constructor(options) {
        super(options);
    }

    public get IsActuallyVisible() {
        return (!this.IsHiddenJurisdiction || (this.IsHiddenJurisdiction && this.ForceShow))
        && !this.FilteredOut && !this.Collapsed && !this.TreatmentFilteredOut;
    }

    public get FilterableText(): string {
        let text = this.Title + " " + this.Year;
        if (this.HowCited) {
            text += " " + this.HowCited;
        }
        if (this.Court) {
            text += " " + this.Court.Name;
        }
        return text;
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/desktop/models/case-relation.ts